var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAbstractShape = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1170,
    height: 421,
    viewBox: "0 0 1170 421",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 101H55.9483C154.936 101 246.174 154.564 294.418 241L331.203 306.908C356.735 352.652 405.021 381 457.409 381V381C516.434 381 569.529 345.107 591.528 290.334L623.648 210.359C679.472 71.366 838.819 4.31342 978.047 59.5496V59.5496C1010.23 72.316 1044.85 79 1079.47 79H1170",
    stroke: "url(#paint0_linear_131_403)",
    strokeOpacity: 0.25,
    strokeWidth: 80
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_131_403",
    x1: 1170,
    y1: 116,
    x2: 3.70778,
    y2: 181.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2158C4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15641,
    stopColor: "#2158C4",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464957,
    stopColor: "#2158C4",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890598,
    stopColor: "#2158C4",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2158C4",
    stopOpacity: 0
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAbstractShape);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/abstract-shape.ddad2fd7b4a716b38fb6498ae41ec737.svg";